module.exports = __webpack_public_path__ + "static/media/img26.a4b5bf2f.jpg";